<template>
  <div>
    <b-form @submit="store">
        <div class="row justify-content-center" >
            <div class="col-md-6 col-11">
                <br>
                <p class="text-center"><b>Plataforma exclusiva para ayudarte a simplificar tu proceso de registro de ventas.</b></p>
                <h4 class="text-center"><b>Conoce tu avance al momento ¡y logra tus metas!</b></h4>
                
                <div class="col-md-11">
                    <img src="fotos/registro.png" style="width: 150px; margin-left: -220px; margin-top: -20px;" >
                </div>
                <div class="row justify-content-center" style="margin-top: -100px;">
                    <div class="col-md-4 mt-5">
                        <label for="" class="text-secondary">Selecciona el tipo de venta</label>
                        <select class="form-control mt-3" v-model="tipo_venta"  style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                            <option value="" selected disabled>Tipo de venta</option>
                            <option value="Pay Joy" >Pay Joy</option>
                            <option value="Renovación" >Renovación</option>
                            <option value="Prepago" >Prepago</option>
                            <option value="Pospago" >Pospago</option>
                        </select>       
                        <small v-if="errors.includes('venta')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>         
                    </div>
                    <div class="col-md-4 mt-5">
                        <label for="" class="text-secondary">Escribe el IMEI de la Terminal</label>
                        <b-form-input placeholder="IMEI" v-model="imei"   type="number"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-3"/>
                         <small v-if="errors.includes('imei15') || imei.length < 15 || imei.length > 15" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Ingresa 15 dígitos
                        </small>  
                        <br>
                        <small v-if="errors.includes('imei')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>     
                    </div>
                    <div class="col-md-4 mt-5">
                        <label for="" class="text-secondary">¿Cuál es la marca?</label>
                        <select class="form-control mt-3" v-model="marca"   style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                            <option value="" selected disabled>Marca</option>
                            <option value="Apple" >Apple</option>
                            <option value="Hisense" >Hisense</option>
                            <option value="Huawei" >Huawei</option>
                            <option value="Motorola" >Motorola</option>
                            <option value="Nokia" >Nokia</option>
                            <option value="Samsung" >Samsung</option>
                            <option value="Otra" >Otra</option>
                        </select>      
                        <small v-if="errors.includes('marca')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>            
                    </div>
                    <div class="col-md-2"></div>
                    <div class="col-md-4 mt-5">
                        <br>
                        <label for="" class="text-secondary">Costo de la Terminal</label>
                        <b-form-input placeholder="Costo" v-model="costo"   type="number" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;" class="mt-3"/> 
                        <small v-if="errors.includes('costo')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>      
                    </div>
                    <div class="col-md-4 mt-5">
                        <br>
                        <label for="" class="text-secondary">Escribe el DN de la Terminal</label>
                        <b-form-input placeholder="DN" v-model="dn"   type="number"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-3"/>
                         <small v-if="errors.includes('dn10') || dn.length < 10 || dn.length > 10" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Ingresa 10 dígitos
                        </small>  
                        <br>
                        <small v-if="errors.includes('dn')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>       
                    </div>
                     <div class="col-md-2"></div>
                </div>
                <br><br><br>
                <span class="mt-5" style="font-size: small; color: #747474;">
                <center>
                    <b>Importante:</b> Cualquier aclaración respecto a comisiones de terminales,
                    deberá contar con registro en cantado, de no ser así, ninguna aclaración procederá para revisión
                </center>
                </span>
                <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">
                <center>
                    <b-button type="submit" variant="primary" pill  style="margin-top: 25px; width: 20%; background: #039cf3; border-color: #CDCDCD;" size="sm" >
                        Registrar  <b-spinner small v-if="loader"></b-spinner>
                    </b-button>
                </center>
    
                <br><br><br>
                
            </div>
         </div>
    </b-form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    name:"Registro",
    data() {
      return {
        tipo_venta:"",
        imei:"",
        marca:"",
        costo:"",
        loader:false,
        errors:[],
        dn:""
      }
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
    },
    methods:{
        store(e){
            e.preventDefault();
            this.loader = true;
            this.errors = []; 
            
            if (!this.tipo_venta) {
                 this.loader = false;
                 this.errors.push('venta');  
            }if (!this.imei){
                 this.loader = false;
                 this.errors.push('imei');      
            }if (!this.marca){
                 this.loader = false;
                 this.errors.push('marca');  
            }if (!this.costo){
                 this.loader = false;
                 this.errors.push('costo');   
             }if (this.imei.length > 15 || this.imei.length < 15){
                 this.loader = false;
                 this.errors.push('imei15');
            }if (!this.dn){
                 this.loader = false;
                 this.errors.push('dn');      
            }if (this.dn.length > 10 || this.dn.length < 10){
                 this.loader = false;
                 this.errors.push('dn10');
            }if(this.errors.length == 0){
                let model = this.prepareModel();
                this.$api.post("cantado/store", model).then(
                response => {
                    this.loader = false;
                    if (response.data.valida == 1)
                    {
                        Swal.fire({
                            icon: 'error',
                            title: 'IDPDV no vigente.',
                            text: 'No se encontro el punto de venta.'
                        })
                    }else{
                        Swal.fire(
                        "List@",
                        "Registro de terminal enviada exitosamente.",
                        'success'
                        )
                        this.clearMode();
                        console.log(response)
                    }
                },
                error => {
                    this.loader = false;
                    if (error.api) {
                         this.errors = error.api; 
                    }
                }
                )
             }
        },
        prepareModel() {
             var model = new FormData();
                model.append("pdv", this.user.id_pdv);
                model.append("axc", this.user.mrt);
                model.append("tipo", this.tipo_venta);
                model.append("imei", this.imei);
                model.append("marca", this.marca);
                model.append("costo", this.costo);
                model.append("nombre", this.user.nombre);
                model.append("dn", this.dn);
                return model;
        },
        clearMode(){
            this.tipo_venta = "";
            this.imei = "";
            this.marca = "";
            this.costo = "";
            this.dn = "";
        }
    }
}
</script>

<style>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>